(function() {

	angular
		.module('ngmvac')
		.filter('rateFilter', RateFilter);

	function RateFilter() {
		return function(arr) {
			var rateArray = [];

			angular.forEach(arr, function(hotel) {
				angular.forEach(hotel.rooms, function(room) {
					angular.forEach(room.rates, function(rate) {
						rateArray.push(rate);
					});
				});
			});

			return rateArray;
		} 
	}

})();